<template>
  <div class="collectVideoList">
    <p class="dragTitle" v-if="status">
      <img
        class="titleImg"
        src="/static/collect/icon_playlist_info_sort@2x.png"
        alt=""
      />{{$t('collect.拖拽可调整排序')}}
    </p>
    <div class="clearfix">
      <draggable
        v-model="list"
        chosenClass="chosen"
        forceFallback="true"
        group="people"
        animation="500"
        :disabled="!status"
        @change="changeVideo"
      >
        <div
          class="dragBox"
          :class="{ hoverCla: status&&ishove&&index==i }"
          v-for="(item, i) in list"
          :key="i"
          @mouseover="ishove = true,index=i"
          @mouseout="ishove = false"
          @click.stop.prevent="gotoRouter('video', item.id)"
        >
          <div class="fontIcon">
            <img
              class="fontImg"
              src="/static/collect/icon_playlist_sort@2x.png"
              alt=""
            />
          </div>
          <div class="imgBox">
            <img
              v-if="item.thumb"
              class="imgs"
              :src="
                item.thumb | imageUrl('/static/collect/default.png', 470, 264)
              "
              alt=""
            />
          </div>
          <p class="title">
            {{ language === "zh" ? item.title : item.enTitle || item.title }}
          </p>
          <div
            class="nameBox"
            @click.stop.prevent="gotoRouter('people', item.userId)"
          >
            <img
              class="aravImg"
              :src="item.userAccountDomain.avatar | imageUrl('', 40, 40)"
              alt=""
            />{{ item.userAccountDomain.nickName }}
          </div>
          <div @click.stop.prevent>
            <el-popover placement="bottom" trigger="hover">
              <div class="operationTitle">
                <p class="title1" @click="closeVideo(item.id)">{{$t('collect.取消收藏')}}</p>
                <p class="title1" @click="moveVideo(item.id)">{{$t('collect.移动到')}}</p>
              </div>
              <span class="operation" slot="reference" @click.stop.prevent
                ><img
                  src="/static/collect/icon_playlist_video_dots@2x.png"
                  alt=""
              /></span>
            </el-popover>
          </div>
        </div>
      </draggable>
    </div>
    <div class="createPop" v-if="cleateLookPop">
      <div class="popBox" v-if="type == 1">
        <p class="popTitle">
          <span class="title1">{{$t('collect.移动到看单')}}</span>
          <img
            class="close"
            @click="cleateLookPop = false"
            src="/static/close_btn@2x.png"
            alt=""
          />
        </p>
        <div class="from1">
          <div
            class="nameBox"
            v-for="(item, i) in createList"
            :key="i"
            :class="{ notActive: item.id == id }"
          >
            <div class="selectBox" @click="selectLook(item, i)">
              <span class="seleBox" v-if="isSelect == i"><i></i></span
              ><span v-else class="textBox"></span>
              <span class="textTi">{{ item.name }}</span>
            </div>
            <img
              v-if="item.isSecret == 1"
              class="privateIcon"
              src="/static/collect/icon_playlist_locked@2x.png"
              alt=""
            />
          </div>
        </div>
        <div class="buttom1">
          <div class="butBox1">
            <span class="cel" @click="cleateLookPop = false">{{$t('collect.取消')}}</span
            ><span class="cir" @click="saveLook">{{$t('collect.确定')}}</span>
          </div>
        </div>
      </div>
      <div class="popBox popBox1" v-if="type == 2">
        <p class="popTitle">
          <span class="title1">{{$t('collect.取消收藏')}}</span>
        </p>
        <p class="textTitle">{{$t('collect.是否取消收藏该视频？')}}</p>
        <div class="buttom1 buttom2">
          <div class="butBox1">
            <span class="cel" @click="cleateLookPop = false">{{$t('collect.否')}}</span
            ><span class="cir" @click="closeLook">{{$t('collect.是')}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
  name: "collectVideoList",
  props: ["list", "id"],
  data() {
    return {
      cleateLookPop: false,
      createList: [],
      videoId: null,
      type: null,
      isSelect: null,
      toId: null,
      status: true,
      index: null,
      ishove: false
    };
  },
  components: {
    draggable,
  },
  created() {},
  watch: {
    $route(val) {
      if (val.query.type && val.query.type == 2) {
        this.status = false;
      } else {
        this.status = true;
      }
    },
  },
  methods: {
    moveVideo(id) {
      this.videoId = id;
      this.isSelect = null;
      this.$http.get("/api/fav/collectVideo/" + id).then((res) => {
        if (res.code === "OK") {
          this.createList = res.data;
          this.cleateLookPop = true;
          this.type = 1;
        }
      });
    },
    selectLook(item, i) {
      if (item.id == this.id) {
        return;
      }
      this.toId = item.id;
      this.isSelect = i;
    },
    saveLook() {
      if (!this.toId) {
        this.$message.warning(this.$t('collect.请至少选择一个看单！'))
        return
      }
      let params = {
        fromId: this.id,
        toId: this.toId,
        videoId: this.videoId,
      };
      this.$http
        .post("/api/u/fav/moveVideo", params, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          if (res.code === "OK") {
            this.$message.success(res.message);
            this.cleateLookPop = false;
            this.$emit("getList");
          }
        });
    },
    closeLook() {
      let params = {
        videoId: this.videoId,
        favoritesId: this.id,
      };
      this.$http
        .post("/api/u/fav/calcleVideo", params, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.$message.success(res.message);
          this.$emit("getList");
          this.cleateLookPop = false;
        });
    },
    closeVideo(id) {
      // this.cleateLookPop = true;
      // this.type = 2;
      this.videoId = id;
      this.closeLook();
    },
    changeVideo(e) {
      let params = {
        id: this.id,
        sort: this.list[e.moved.newIndex + 1].sort,
        videoId: e.moved.element.id,
      };
      this.$http
        .post("/api/u/fav/setSort", params, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          if (res.code === "OK") {
            this.$message.success(res.message);
          }
        });
    },
    gotoRouter(path, id) {
      let routeData = null;
      if (path == "video") {
        routeData = this.$router.resolve({
          path: "/video/detail?id=" + id,
        });
      }
      if (path == "people") {
        routeData = this.$router.resolve({
          path: "/peopleCenter/" + id + "/home",
        });
      }
      window.open(routeData.href, "_blank");
    },
  },
  computed: {
    language() {
      return this.$language();
    },
  },
};
</script>
<style>
/* .el-popover {
  min-width: auto;
  padding: 10px 0;
} */
.operationTitle .title1 {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  text-align: center;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
  cursor: pointer;
}
.operationTitle .title1:hover {
  background: #f5f5f5;
}
</style>
<style lang="stylus" scoped>
.collectVideoList {
  padding: 24px 23px 50px;

  .dragTitle {
    height: 20px;
    font-size: 13px;
    font-weight: 400;
    color: #B8B8B8;
    line-height: 20px;
    margin-bottom: 4px;

    .titleImg {
      width: 14px;
      height: 14px;
      vertical-align: text-bottom;
    }
  }

  .dragBox {
    width: 259px;
    height: 245px;
    float: left;
    padding: 0 12px;
    box-sizing: border-box;
    position: relative;
    cursor: pointer;

    .fontIcon {
      height: 20px;
      line-height: 20px;
      text-align: center;

      .fontImg {
        display: none;
        width: 18px;
        height: 10px;
        margin-bottom: 3px;
      }
    }

    .imgBox {
      width: 235px;
      height: 133px;

      .imgs {
        width: 100%;
        height: 100%;
      }
    }

    .title {
      height: 40px;
      font-size: 13px;
      font-weight: 600;
      color: #0A0A0A;
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      word-break: break-word;
      margin: 8px 0;
    }

    .nameBox {
      height: 20px;
      font-size: 12px;
      font-weight: 400;
      color: #666666;
      line-height: 20px;
      width: 210px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      .aravImg {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        vertical-align: middle;
        margin-right: 6px;
      }
    }

    .operation {
      position: absolute;
      right: 0;
      bottom: 15px;
      width: 30px;
      height: 30px;
      img {
        width: 20px;
        height: 20px;
        margin-top: 5px;
      }
    }
  }

  .hoverCla {
    background: #F5F5F5;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.3);

    .fontIcon {
      .fontImg {
        display: inline-block;
      }
    }
  }

  .createPop {
    position: fixed;
    width: 100%;
    height: 100vh;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 999;

    .popBox {
      width: 445px;
      height: 362px;
      background: rgba(255, 255, 255, 1);
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);

      .popTitle {
        height: 60px;
        line-height: 60px;
        padding-left: 24px;
        box-sizing: border-box;
        position: relative;
        border-bottom: 1px solid #E0E0E0;

        .title1 {
          font-size: 16px;
          font-weight: 400;
          color: #333333;
          margin-right: 16px;
        }

        .title2 {
          font-size: 12px;
          font-weight: 400;
          color: #999999;
        }

        .close {
          position: absolute;
          right: 24px;
          top: 23px;
          width: 13px;
          height: 13px;
          cursor: pointer;
        }
      }

      .from1 {
        padding: 20px 24px 0;
        height: 230px;
        box-sizing: border-box;
        overflow-y: scroll;

        .nameBox {
          margin-bottom: 16px;
          cursor: pointer;
          font-size: 15px;
          font-weight: 400;
          color: #333333;

          .selectBox {
            display: inline-block;
          }

          img {
            width: 18px;
            height: 18px;
            margin-right: 10px;
          }

          .textTi {
            display: inline-block;
            max-width: 330px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            vertical-align: middle;
          }

          .seleBox {
            display: inline-block;
            width: 20px;
            height: 20px;
            border: 1px solid #2026CC;
            border-radius: 50%;
            box-sizing: border-box;
            vertical-align: middle;
            margin-right: 10px;
            position: relative;

            i {
              position: absolute;
              width: 10px;
              height: 10px;
              background: #2026CC;
              border-radius: 50%;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
            }
          }

          .textBox {
            display: inline-block;
            width: 20px;
            height: 20px;
            border: 1px solid #B8B8B8;
            border-radius: 50%;
            box-sizing: border-box;
            vertical-align: middle;
            margin-right: 10px;
          }

          .privateIcon {
            width: 16px;
            height: 16px;
            margin-right: 0;
          }
        }

        .notActive {
          color: #999999;
          cursor: not-allowed;

          .textBox {
            background: #EBEBEB;
            border: 1px solid #B8B8B8;
          }
        }
      }

      .buttom1 {
        border-top: 1px solid #E0E0E0;
        height: 70px;
        padding: 20px 24px;
        box-sizing: border-box;
        text-align: center;

        .create {
          float: left;
          font-size: 15px;
          font-weight: 400;
          color: #3664ED;
          cursor: pointer;
        }

        .butBox1 {
          .cel {
            width: 90px;
            height: 30px;
            line-height: 30px;
            font-size: 14px;
            font-weight: 600;
            display: inline-block;
            text-align: center;
            vertical-align: middle;
            margin-right: 20px;
            cursor: pointer;
            border: 1px solid #999999;
            color: #333333;
          }

          .cir {
            background: #2026CC;
            color: #FFFFFF;
            width: 90px;
            height: 30px;
            box-sizing: border-box;
            line-height: 30px;
            font-size: 14px;
            font-weight: 600;
            display: inline-block;
            text-align: center;
            vertical-align: middle;
            cursor: pointer;
          }
        }
      }
    }

    .popBox1 {
      height: 220px;
      width: 380px;

      .textTitle {
        height: 24px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        line-height: 24px;
        text-align: center;
        margin: 27px 0 32px 0;
      }

      .buttom2 {
        border-top: none;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/collect/collectVideoList.vue